module.exports = __webpack_public_path__ + "media/images/map-icons/google-terrain-d2953a4e5cfb9cc9e176d61b0363644c.png";